import React from 'react';
import { Trans } from 'react-i18next';
import UserLink from '../../../User/Link/UserLink';
import { BiLoggerContextProvider, BiLink, BiEventType, } from '../../../biLogger';
import { GallectionResourceType } from '../../../types/gallection';
import { Url } from '@wix/da-url';
import SidebarBlock from '../../_partials/SidebarBlock';
import DeviationSidebarGrid from '../../_partials/DeviationSidebarGrid';
import { ResourceType } from '../../../types/resource';
import s from './CollectionsBlock.scss';
export var CollectionsBlock = function (_a) {
    var collections = _a.collections, parentDeviation = _a.parentDeviation;
    if (!collections || !collections.length) {
        return null;
    }
    var CollectionLink = function (_a) {
        var collection = _a.collection;
        return (React.createElement(BiLink, { className: s['by-author'], href: Url.userGalleryLink({
                username: collection.owner.username,
                gallectionType: 'collection',
                folderId: collection.folderId,
                folderName: collection.name,
            }), biData: {
                evid: BiEventType.THUMB_CLICK,
                sectionname: 'collections',
                typeid: ResourceType.COLLECTION,
                itemid: collection.folderId,
            } }, collection.name));
    };
    return (React.createElement(SidebarBlock, { streamKey: "collections", className: s['collection-block'], titleClassname: s['block-title'], headerClassname: s['block-header'] }, collections
        .filter(
    // backend can produce weird results...
    function (collection) {
        return collection &&
            collection.collection &&
            collection.deviations &&
            collection.deviations.length;
    })
        .map(function (_a) {
        var collection = _a.collection, deviations = _a.deviations;
        return (React.createElement(React.Fragment, { key: collection.folderId },
            React.createElement(BiLoggerContextProvider, { value: {
                    sectionname: 'collections',
                    section_typeid: GallectionResourceType.COLLECTION,
                    sectionid: collection.folderId,
                } },
                React.createElement("div", { className: s['collection-header'] },
                    React.createElement("div", { className: s['by-author-title'] },
                        React.createElement(Trans, { i18nKey: "sidebar.collections.title" },
                            React.createElement(CollectionLink, { collection: collection }),
                            "\u00A0by\u00A0",
                            React.createElement(UserLink, { user: collection.owner, className: s['by-author'] })))),
                React.createElement(DeviationSidebarGrid, { streamId: "devpage-sidebar-collections", className: s['collection-grid'], parentDeviation: parentDeviation, deviations: deviations, maxRows: 1 }))));
    })));
};
CollectionsBlock.displayName = 'CollectionsBlock';
export default CollectionsBlock;
//# sourceMappingURL=CollectionsBlock.js.map